/**
 * Sör jellege:   * CLEAR - világos   * HALF_BROWN - félbarna   * BROWN - barna   * BLACK - fekete   * RED - vörös   * UNFILTERED - szűretlen   * WHEAT - búza   * COLD_HOPPED - hidegkomlós   * DOUBLE_HOPPED - duplakomlós   * TRIPLE_CHERRY - triplameggyes   * FLAVORED - ízesített   * OTHER - egyéb
 */
export type CharacterOfBeer =
  | 'CLEAR'
  | 'HALF_BROWN'
  | 'BROWN'
  | 'BLACK'
  | 'RED'
  | 'UNFILTERED'
  | 'WHEAT'
  | 'COLD_HOPPED'
  | 'DOUBLE_HOPPED'
  | 'TRIPLE_CHERRY'
  | 'FLAVORED'
  | 'OTHER';

export const CharacterOfBeer = {
  Clear: 'CLEAR' as CharacterOfBeer,
  HalfBrown: 'HALF_BROWN' as CharacterOfBeer,
  Brown: 'BROWN' as CharacterOfBeer,
  Black: 'BLACK' as CharacterOfBeer,
  Red: 'RED' as CharacterOfBeer,
  Unfiltered: 'UNFILTERED' as CharacterOfBeer,
  Wheat: 'WHEAT' as CharacterOfBeer,
  ColdHopped: 'COLD_HOPPED' as CharacterOfBeer,
  DoubleHopped: 'DOUBLE_HOPPED' as CharacterOfBeer,
  TripleCherry: 'TRIPLE_CHERRY' as CharacterOfBeer,
  Flavored: 'FLAVORED' as CharacterOfBeer,
  Other: 'OTHER' as CharacterOfBeer,
};
